import MuiFormControl, { type FormControlProps } from "@mui/material/FormControl";
import MuiFormControlLabel, { type FormControlLabelProps } from "@mui/material/FormControlLabel";
import MuiFormGroup, { type FormGroupProps } from "@mui/material/FormGroup";
import MuiFormHelperText, { type FormHelperTextProps } from "@mui/material/FormHelperText";
import MuiFormLabel, { type FormLabelProps } from "@mui/material/FormLabel";

export type { FormControlProps, FormControlLabelProps, FormGroupProps, FormHelperTextProps, FormLabelProps };

export function FormControl(props: FormControlProps) {
  return <MuiFormControl {...props} />;
}
export function FormControlLabel(props: FormControlLabelProps) {
  return <MuiFormControlLabel {...props} />;
}
export function FormGroup(props: FormGroupProps) {
  return <MuiFormGroup {...props} />;
}
export function FormHelperText(props: FormHelperTextProps) {
  return <MuiFormHelperText {...props} />;
}
export function FormLabel(props: FormLabelProps) {
  return <MuiFormLabel {...props} />;
}
